import { Button, Grid, Paper } from "@material-ui/core";
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import CustomInput from "components/CustomInput";
import { questionTypes } from "features/Forms/formBuilder/formBuilderConsts";
import { EditFormOutputStyle } from "../style";
import { DateComponent } from "./DateComponent";
import { DropdownComponent } from "./DropdownComponent";
import { ImageComponent } from "./ImageComponent";
import { MultipleChoiceComponent } from "./MultipleChoiceComponent";
import { TextComponent } from "./TextComponent";

export const Question = ({ question, formAnswers, setFormAnswers, showFailuresOnly, getIsFailure, containerRef, isPending }) => {
    const classes = EditFormOutputStyle();

    const questionTypeComponents = {
        [questionTypes.Freetext]: TextComponent,
        [questionTypes.Date]: DateComponent,
        [questionTypes.Dropdown]: DropdownComponent,
        [questionTypes.Image]: ImageComponent,
        [questionTypes.MultipleChoice]: MultipleChoiceComponent,
        //[questionTypes.Boolean]: BooleanComponent,
    };

    const QuestionComponent = questionTypeComponents[question?.questionType];

    const getValues = () => {
        if (question?.values) {
            let valuesObj = question?.values;
            if (typeof question?.values === 'string' && question?.values.startsWith('[')) {
                valuesObj = JSON.parse(question?.values);
            }
            let valuesObjReturn = Array.isArray(valuesObj) ? valuesObj?.map((v, i) => {
                return { ...v, id: v.id ?? v.value, name: v.value }
            }) : [];
            return valuesObjReturn;
        } else {
            return null
        }
    }

    const getImageValue = () => {
        if (formAnswers?.[question.id]?.pictureObj) {
            return formAnswers?.[question.id]?.pictureObj?.url
        }
        return formAnswers?.[question.id]?.pictureUrl;
    }

    const getValue = () => {
        switch (question?.questionType) {
            case questionTypes.Image:
            case questionTypes.Signature:
                return getImageValue()
            case questionTypes.Dropdown:
                return formAnswers?.[question.id]?.dropdownValue ?? formAnswers?.[question.id]?.freetextValue;
            case questionTypes.Date:
                return formAnswers?.[question.id]?.dateValue;
            case questionTypes.Freetext:
                return formAnswers?.[question.id]?.freetextValue;
            case questionTypes.MultipleChoice:
                return formAnswers?.[question.id]?.multipleChoiceValue;
            default:
                return formAnswers?.[question.id]?.values
        }
    }

    const onChangeValue = (val, key) => {
        let newAnswer;
        if (formAnswers?.[question.id]) {
            newAnswer = { ...formAnswers?.[question.id], [key]: val };
        } else {
            newAnswer = {
                ...question,
                id: 0,
                questionId: question.id,
                customFormResponseId: 0,
                [key]: val
            }
        }
        setFormAnswers({ ...formAnswers, [question.id]: newAnswer });
    }

    const failureValues = getValues()?.filter(val => val?.isFailure);
    const value = getValue();
    const showQuestion = showFailuresOnly ? getIsFailure(failureValues, value) : true;

    return (
        showQuestion ?
            <Paper ref={containerRef} className={`${classes.question} ${isPending ? classes.questionPending : ''}`}>
                <Grid container direction="column" spacing={4}>
                    <Grid item>
                        <div className={classes.questionTitle}>
                            <b>{question?.question}{question.required && <label className={classes.required}> *</label>}</b>
                            {getIsFailure(failureValues, value) &&
                                <Button
                                    variant="outlined"
                                    startIcon={<ErrorOutlineRoundedIcon
                                        className={classes.failureIcon}
                                    />}
                                    disabled
                                    className={classes.failureButton}
                                >
                                    Failure
                                </Button>
                            }
                        </div>
                        <div>
                            {QuestionComponent ? <QuestionComponent
                                value={getValue()}
                                values={getValues()}
                                onChange={(val, key) => onChangeValue(val, key)} /> :
                                <></>}
                        </div>
                        {!!question?.includeNotes &&
                            <div className={classes.notesAndPhotos}>
                                <CustomInput
                                    elementType='input'
                                    value={formAnswers?.[question.id]?.note}
                                    onChange={(val) => onChangeValue(val, "note")}
                                    label="Note" />
                            </div>}
                        {(!!question?.includePhoto && question?.questionType !== questionTypes.Image) &&
                            <div className={classes.notesAndPhotos}>
                                <ImageComponent
                                    value={getImageValue()}
                                    onChange={(val, key) => onChangeValue(val, key)} />
                            </div>}
                    </Grid>
                </Grid>
            </Paper>
            : <></>
    )
}